
import type { ReactNode } from 'react';
import cn from '../lib/cn';

type Props = {
  icon: ReactNode;
  title: string;
  description?: string;
  className?: string;
};

const EmptyState = ({ icon, title, description, className }: Props) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-20 px-6 text-center col-span-full',
        className,
      )}
    >
      {/* Icon bubble */}
      <div className="relative mb-6">
        <div className="size-20 rounded-2xl bg-theme-slate-800 border border-theme-gray-700 flex items-center justify-center shadow-lg">
          <div className="text-theme-primary opacity-80">{icon}</div>
        </div>
        {/* decorative ring */}
        <div className="absolute inset-0 rounded-2xl ring-1 ring-theme-primary/20 scale-125 opacity-40" />
      </div>

      <h3 className="text-white text-lg font-semibold mb-2">{title}</h3>

      {description && (
        <p className="text-white/50 text-sm max-w-xs leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
};

export default EmptyState;
